import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-modal";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Color } from "../theme/Color";

const customStyles = {
  content: {
    minWidth: "350px",
    maxHeight: "80%",
    maxWidth: "500px",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0",
    transform: "translate(-50%, -50%)",
    border: "none",
    backgroundColor: Color.White,
    overflowX: "hidden",
  },
  overlay: {
    backdropFilter: "blur(3px)",
    zIndex: 10000, // Needs to go over the footer
    backgroundColor: Color.BlackShadow2,
  },
};

const StyledModalTitle = styled.h2<{ titleIsCentered?: boolean }>`
  margin: 0.5rem 1rem;
  font-size: 1.8rem;
  font-weight: bold;
  color: ${Color.White};
  text-align: ${({ titleIsCentered }) => (titleIsCentered ? "center" : "left")};
  width: ${({ titleIsCentered }) => (titleIsCentered ? "100%" : "auto")};
`;

const StyledCloseButton = styled(FontAwesomeIcon)`
  color: ${Color.White};
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

Modal.setAppElement("#__next");

const StyledModal = ({
  title,
  children,
  modalIsOpen,
  setIsOpen,
  afterOpenModal,
  onClose,
  showCloseButton = true,
  titleIsCentered = false,
}: {
  title: string;
  children: any;
  modalIsOpen: any;
  setIsOpen?: any;
  afterOpenModal?: any;
  onClose?: () => void;
  showCloseButton?: boolean;
  titleIsCentered?: boolean;
}) => {
  function closeModal() {
    if (setIsOpen) {
      setIsOpen(false);
    }

    if (onClose) {
      onClose();
    }
  }

  // Don't allow closing if no close handlers are provided
  const canClose = setIsOpen || onClose;

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={canClose ? closeModal : undefined}
      contentLabel="Modal"
      style={customStyles}
      shouldCloseOnOverlayClick={!!canClose}
      shouldCloseOnEsc={!!canClose}
    >
      <Col xs={12} style={{ padding: "0" }}>
        <Row
          style={{
            background: `${Color.Grey1}`,
            padding: "0.5rem",
            margin: "0rem 0rem",
            borderRadius: "0",
          }}
          middle="xs"
        >
          <Col xs={showCloseButton && canClose ? 11 : 12}>
            <Row start="xs">
              <StyledModalTitle titleIsCentered={titleIsCentered}>
                {title}
              </StyledModalTitle>
            </Row>
          </Col>
          {showCloseButton && canClose && (
            <Col xs={1}>
              <Row middle="xs" center="xs">
                <i
                  className={`fa-regular fa-window-close`}
                  style={{
                    color: Color.White,
                    fontSize: "2.5rem",
                  }}
                  onClick={closeModal}
                ></i>
              </Row>
            </Col>
          )}
        </Row>

        <Row style={{ padding: "1rem", maxWidth: "500px" }}>
          <Col xs={12}>{children}</Col>
        </Row>
      </Col>
    </Modal>
  );
};

export default StyledModal;
